"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var langKey = function langKey(key) {
  return "composer-lib.fetchRevisionsFailedError." + key;
};

var _default = (0, _createReactClass.default)({
  displayName: "Revisions500Error",
  propTypes: {
    className: _propTypes.default.string,
    introKey: _propTypes.default.string.isRequired
  },
  render: function render() {
    return _react.default.createElement(_UIErrorMessage.default, {
      className: this.props.className
    }, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: langKey(this.props.introKey)
    }), _react.default.createElement("br", null), _react.default.createElement(_FormattedHTMLMessage.default, {
      message: langKey('refreshLink'),
      options: {
        closeLink: _I18n.default.SafeString('</a>'),
        openLink: _I18n.default.SafeString('<a onclick="window.location.reload()">')
      }
    })), _react.default.createElement("p", {
      className: "m-top-4"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: langKey('outro')
    })));
  }
});

exports.default = _default;
module.exports = exports.default;